'use client';

import { useLegacyServerData } from '@/components/providers/LegacyServerDataProvider';
import { Nullable } from '@/components/types';
import React, { useContext } from 'react';

export type EventContextProviderProps = {
  children: React.ReactNode;
};

interface EventContextData {
  eventTimezone: string;
  currency: string;
  country: string;
  eventStatus: string;
  eventEndDate: string;
  isSeriesParent: boolean;
}

export const EventContext = React.createContext<Nullable<EventContextData>>(null);

export const EventContextProvider: React.FC<EventContextProviderProps> = ({ children }) => {
  const legacyServerData = useLegacyServerData();
  const value: EventContextData = {
    eventTimezone: legacyServerData?.eventStatusData?.timezone ?? 'America/Los_Angeles',
    currency: legacyServerData?.eventStatusData?.currency ?? 'USD',
    country: legacyServerData?.eventStatusData?.country ?? 'US',
    eventStatus: legacyServerData?.eventStatusData?.status ?? '',
    eventEndDate: legacyServerData?.eventStatusData?.end ?? '',
    isSeriesParent: legacyServerData?.isSeriesParent ?? false,
  };
  return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
};

export const useEvent = () => {
  return useContext(EventContext);
};
